import Parse from "parse";

Parse.initialize("vm6477Nnhe8Su0m2CkcleNCKsiViq2w3Lx8gy13k", "7JHYrJSEJqcF");

Parse.serverURL = "https://api.ecomate.cloud/parse";
//Parse.serverURL = 'http://localhost:1337/parse';

export default Parse;
